import React from 'react';
import classnames from 'classnames';

import Label from 'shared/components/Label';
import Tooltip from 'shared/components/Tooltip';
import TextInput from 'shared/components/TextInput';

const TextComponent = (props) => {
  const {
    name,
    inputId,
    label,
    tooltip,
    required,
    errorMessage,
    inputClassName,
    className,
    children,
  } = props;

  return (
    <div className={classnames('form-group', className)}>
      <Label htmlFor={inputId} label={label} required={required}>
        <Tooltip id={`tooltip-${name}`} title={tooltip} />
      </Label>
      <TextInput
        {...props}
        inputClassName={classnames(errorMessage && 'error', inputClassName)} />
      <span className="error">
        {errorMessage}
      </span>
      {children}
    </div>
  );
};

TextComponent.defaultProps = {
  label: '',
  required: false,
};

export default TextComponent;
